import Image from "next/image";
import Link from "next/link";
import { HomeFooter } from "@/components/boardblend/home-footer";
import { LegalHeader } from "@/components/boardblend/legal-header";
import { SeoScrollPage } from "@/components/seo/seo-scroll-page";
import { PublicPageHead } from "@/components/seo/public-page-head";
import { publishedSeoPages } from "@/generated/seo-metadata";
import {
  getCanonicalUrl,
  SITE_ORIGIN,
  SITE_WEBSITE_ID,
  staticPublicPages,
} from "@/lib/public-seo";
import styles from "@/components/seo/seo-page.module.css";

const page = staticPublicPages.resources;
const canonical = getCanonicalUrl(page.path);
const structuredData = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "CollectionPage",
      "@id": `${canonical}#webpage`,
      url: canonical,
      name: page.title,
      description: page.description,
      dateModified: page.lastModified,
      isPartOf: { "@id": SITE_WEBSITE_ID },
      mainEntity: {
        "@type": "ItemList",
        itemListElement: publishedSeoPages.map((resource, index) => ({
          "@type": "ListItem",
          position: index + 1,
          name: resource.title,
          url: resource.canonical,
        })),
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: `${SITE_ORIGIN}/`,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Resources",
          item: canonical,
        },
      ],
    },
  ],
};

export default function ResourcesPage() {
  return (
    <>
      <PublicPageHead page={page} structuredData={structuredData} />
      <SeoScrollPage routeKey="resources">
        <LegalHeader />
        <section className={styles.article}>
          <header className={styles.hero}>
            <p className={styles.eyebrow}>BOARD﻿BLEND RESOURCES</p>
            <h1>Better ways to think and decide together.</h1>
            <p className={styles.description}>
              Practical workshops, decision frameworks, and honest comparisons
              for teams working with AI.
            </p>
          </header>

          <div className={styles.resourceGrid}>
            {publishedSeoPages.map((page) => (
              <article key={page.slug} className={styles.resourceCard}>
                {page.hero && (
                  <div className={styles.resourceImage}>
                    <Image
                      fill
                      alt=""
                      sizes="(max-width: 720px) 100vw, 50vw"
                      src={page.hero.src}
                      unoptimized={page.hero.src.endsWith(".svg")}
                    />
                  </div>
                )}
                <p className={styles.eyebrow}>{page.type}</p>
                <h2>
                  <Link href={`/resources/${page.slug}`}>{page.title}</Link>
                </h2>
                <p>{page.description}</p>
              </article>
            ))}
          </div>
        </section>
        <HomeFooter />
      </SeoScrollPage>
    </>
  );
}
